"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tableDictionary = void 0;
exports.tableDictionary = {
    applyBtnLabel: 'Filter - Apply',
    approvalAuthority: 'Tab Table - Approval authority',
    archived: 'Tab Table - Archived',
    authority: 'authority',
    cancelBtnLabel: 'Filter - Cancel',
    closeBtnLabel: 'Filter - Close',
    communicationErrorMessage: 'Communication Error Message',
    description: 'description',
    doneBtnLabel: 'Filter - Done',
    download: 'download',
    durationLabel: 'Duration',
    enrollButtonLabel: 'Enroll',
    expirationDate: 'Tab Table - Expiration date',
    fileType: 'fileType',
    filterBtnLabel: 'Filter - Filter',
    filterHeaderDefaultLabel: 'Filter - Filter by',
    globalTooltipMessage: 'Valid for - Global tooltip message',
    languages: 'languages',
    learningTypeLabel: 'Search Group Filters - Learning event type',
    languagesLabel: 'Tab Table - Language',
    loadLessBtnLabel: 'Load less',
    loadMoreBtnLabel: 'Load more',
    multilanguageLabel: 'Tab Table - Multilanguage',
    multipleLabel: 'Valid for - Multiple label',
    multipleTooltipMessage: 'Valid for - Multiple tooltip message',
    name: 'name',
    nameLabel: 'Tab Table - Name',
    noDataLabel: 'Tab Table - There are no assets to display',
    released: 'Tab Table - Released',
    resetAllFiltersLabel: 'Tab Table - Reset all filters',
    resetBtnLabel: 'Tab Table - Reset',
    resetFilterLabel: 'Tab Table - Reset filter',
    showMoreAriaLabel: 'Show more',
    sortBtnLabel: 'Sort - Sort by',
    sortTitleAscLabel: 'Sort - Name A-Z',
    sortTitleDescLabel: 'Sort - Name Z-A',
    sortAllLabel: 'Sort - All',
    ascendingSortAriaLabel: 'Accessibility label - Sorting - Ascending order',
    descendingSortAriaLabel: 'Accessibility label - Sorting - Descending order',
    notSortedAriaLabel: 'Accessibility label - Sorting - Not sorted',
    status: 'status',
    type: 'type',
    softwareCharacteristic: 'Tab Table - Software Characteristic',
    updated: 'updated',
    updatedTimestamp: 'updatedTimestamp',
    validFor: 'validFor',
    version: 'version',
    expandRow: 'Accessibility label - Expand row',
    collapseRow: 'Accessibility label - Collapse row',
    zeroResultMessage: 'Downloads List - Zero Result Message',
    search: 'Search',
};
